import {logAction} from "../../../logging/logEvent";
import React from "react";
import IdeaDetailsCloseTab from "./close/IdeaDetailsCloseTab";
import PaddedSection from "./PaddedSection";
import {Author} from "./Author";
import {RecommendationRows} from "./recommendation/RecommendationRows";
import ContentToggle from "../../elements/ContentToggle";
import styled from "styled-components";
import IdeaDetailsViewTab from "./view/IdeaDetailsViewTab";
import IdeaDetailsHistoryTab from "./history/IdeaDetailsHistoryTab";

const ideaDetailsTabFor = (tab) => {
    if (tab === "view") {
        return IdeaDetailsViewTab;
    } else if (tab === "close") {
        return IdeaDetailsCloseTab;
    } else if (tab === "history") {
        return IdeaDetailsHistoryTab;
    }
};

const Content = styled.div`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
`;

const AuthorSection = styled(PaddedSection)`
    padding-top: 32px;
`;

const RecommendationsSection = styled(PaddedSection)`
    padding-top: 26px;
    padding-bottom: 32px;
`;

const ContentToggleSection = styled.div`
    z-index: 2;
    padding-bottom: 32px;
`;

const DisclaimerSection = styled(PaddedSection)`
    padding-bottom: 32px;
`;

const DisclaimerHeading = styled.h5``;
const DisclaimerText = styled.div`
    font-size: 80%;
    max-height: 90px;
    overflow: scroll;
    overflow-x: hidden;
    color: rgba(0,0,0,0.75);
`;

export const IdeaDetails = ({ideaDetails, userIdentity, closeModal, ideaActions, checkIdeaClosed, clock}) => {
    const {data: idea, closing, currentTab, history} = ideaDetails;

    function linkClicked(buttonName, details) {
        logAction({type: `${buttonName}_LINK_IN_IDEA_MODAL_CLICKED`, ...details});
        closeModal();
    }

    let authorSection = null;
    const tabs = [
        {id: "view", label: "View Idea"},
        {id: "history", label: "Idea History"}
    ];
    if (!userIdentity.ideaManagementBlocked && userIdentity.imeUserId === idea.authorId && idea.portfolios.filter(p => p.open).length > 0) {
        tabs.unshift({id: "close", label: "Close Idea"});
    } else {
        authorSection = <AuthorSection>
            <Author authorName={idea.authorName} authorId={idea.authorId} authorCompanyName={idea.authorCompanyName}
                    linkClicked={linkClicked}/>
        </AuthorSection>;
    }
    const showDisclaimer = (userIdentity.imeUserId !== idea.authorId) && idea.disclaimer;
    const tabContent = ideaDetailsTabFor(currentTab);

    if (!tabContent) throw new Error("No idea details tab: " + currentTab);

    return (
        <Content className="t-idea-details">
            {authorSection}
            <RecommendationsSection>
                <RecommendationRows idea={idea} linkClicked={linkClicked}/>
            </RecommendationsSection>
            {
                tabs.length <= 1 ? null :
                    (<ContentToggleSection>
                        <ContentToggle items={tabs}
                                       current={currentTab}
                                       sideMargins="142px"
                                       onToggle={(id) => {
                                           logAction({
                                               "type": "IDEA_DETAILS_TAB_CHANGED",
                                               "tab": id
                                           });
                                           ideaActions.updateCurrentTab(id);
                                       }}/>
                    </ContentToggleSection>)
            }
            {React.createElement(tabContent, {
                idea,
                userIdentity,
                ideaActions,
                ideaDetails,
                closing,
                history,
                checkIdeaClosed,
                clock
            })}
            {showDisclaimer ? <DisclaimerSection className="t-disclaimer">
                <DisclaimerHeading>Disclaimer</DisclaimerHeading>
                <DisclaimerText className="t-disclaimer-text">{idea.disclaimer}</DisclaimerText>
            </DisclaimerSection> : null}
        </Content>
    );
};